var VersionHelper = /** @class */ (function () {
    function VersionHelper() {
    }
    VersionHelper.getNumberArray = function (str) {
        return str
            .split('.')
            .map(Number)
            .map(function (n) { return (isNaN(n) ? 0 : n); });
    };
    // target이 작거나 같으면 true
    VersionHelper.isLower = function (target, compare) {
        var targetArr = this.getNumberArray(target);
        var compareArr = this.getNumberArray(compare);
        var len = Math.max(targetArr.length, compareArr.length);
        var result = -1;
        var current = 0;
        while (result < 0 && len > current) {
            if (targetArr[current] > compareArr[current])
                result = +true;
            if (targetArr[current] < compareArr[current])
                result = +false;
            current++;
        }
        return result <= 0;
    };
    return VersionHelper;
}());
export default VersionHelper;
